import React, { useEffect, useState } from "react";
import { fetchPaymentHistory } from "../../../services/profile/PaymentHistoryService"; // Adjusted import

const StudentsPaymentHistory = ({ userId }) => {
	const [payments, setPayments] = useState([]);

	useEffect(() => {
		const fetchPayments = async () => {
			try {
				const paymentData = await fetchPaymentHistory(userId);
				setPayments(paymentData);
			} catch (error) {
				console.error("Error fetching payment history:", error);
			}
		};

		fetchPayments();
	}, [userId]);

	const duePayments = payments.filter(
		(payment) =>
			payment.status.toLowerCase() === "pending" ||
			payment.status.toLowerCase() === "not verified"
	);

	const paidPayments = payments.filter(
		(payment) => payment.status.toLowerCase() === "success"
	);

	return (
		<div className="max-w-4xl mx-auto my-8 font-sans p-6 bg-white rounded-lg shadow-lg">
			<h2 className="text-3xl font-bold text-gray-800 mb-6">
				Payment History
			</h2>

			{/* Due Payments Section */}
			<div className="mb-8">
				<h3 className="text-2xl font-semibold text-gray-700 mb-4">
					Pending Payments
				</h3>
				{duePayments.length > 0 ? (
					<div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
						{duePayments.map((payment) => (
							<div
								key={payment._id}
								className="flex justify-between items-center mb-3 last:mb-0"
							>
								<div>
									<p className="font-medium text-gray-800">
										{payment.classroomId.courseId.name}
									</p>
									<p className="text-sm text-gray-600">
										Date:{" "}
										{new Date(
											payment.paymentDate
										).toLocaleDateString()}
									</p>
								</div>
								<div className="text-right">
									<p className="font-bold text-gray-800">
										${payment.amount}
									</p>
									<p className="text-sm text-gray-600">
										Status: {payment.status}
									</p>
								</div>
							</div>
						))}
					</div>
				) : (
					<p className="text-green-600 font-medium">
						No due payments. You're all caught up!
					</p>
				)}
			</div>

			{/* Past Payments Section */}
			<div>
				<h3 className="text-2xl font-semibold text-gray-700 mb-4">
					Past Payments
				</h3>
				<div className="bg-gray-50 rounded-lg overflow-hidden">
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-100">
							<tr>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Date
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Course
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Amount
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Status
								</th>
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
							{paidPayments.map((payment) => (
								<tr key={payment._id}>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
										{new Date(
											payment.paymentDate
										).toLocaleDateString()}
									</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
										{payment.classroomId.courseId.name}
									</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
										${payment.amount}
									</td>
									<td className="px-6 py-4 whitespace-nowrap">
										<span
											className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
												payment.status === "success"
													? "bg-green-100 text-green-800"
													: "bg-red-100 text-red-800"
											}`}
										>
											{payment.status}
										</span>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default StudentsPaymentHistory;
